import debug from "debug";
import LoadingOverlay from "./LoadingOverlay"; // Adjust path as needed

const log = debug("app:loading3d");

class Loading3D {
    private experience: any;
    private eventHub: any;
    private loadingOverlay: LoadingOverlay;

    constructor(experience: any) {
        this.experience = experience;
        this.eventHub = experience.eventHub;

        this.loadingOverlay = new LoadingOverlay(this.experience);

        log("Initializing Loading3D");
        this.initListeners();
    }

    cleanup() {
        this.eventHub.off("3d-enabled", this.handleViewSwitch);
        this.eventHub.off("loading-finished", this.loadingOverlay.hideLoadingOverlay);
        this.loadingOverlay.cleanup();
        log("Cleaned up Loading3D");
    }

    private initListeners() {
        this.eventHub.on("3d-enabled", (event: { enabled: boolean }) => this.handleViewSwitch(event.enabled));
        this.eventHub.on("loading-finished", () => this.loadingOverlay.hideLoadingOverlay());
    }

    private handleViewSwitch(enabled: boolean) {
            log("3D mode enabled — showing loading overlay");
            this.loadingOverlay.showLoadingOverlay();
    }
}

export default Loading3D;